import React from "react";
import { ArrowDown, Calendar } from "lucide-react";
import Embers from "./Embers";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative w-full min-h-screen overflow-hidden bg-pkcharcoal"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('/images/7vofl2kc.jpg')",
        }}
      />

      {/* Layered overlays */}
      <div className="absolute inset-0 hero-overlay" />
      <div className="absolute inset-0 heat-shimmer bg-gradient-to-t from-pkred/10 via-transparent to-transparent" />
      <div className="grain" />

      {/* Embers */}
      <Embers count={22} />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        <div className="flex-1 max-w-7xl mx-auto px-5 sm:px-8 w-full flex items-end pb-24 sm:pb-32 pt-32">
          <div className="max-w-4xl">
            <div className="flex items-center gap-3 mb-8 fade-in-up">
              <span className="block w-10 h-px bg-pkred shadow-[0_0_10px_rgba(217,4,41,0.8)]" />
              <span className="hero-fire-label text-pkred text-[0.7rem] sm:text-xs tracking-[0.4em] uppercase font-semibold">
                Vezseny · Tisza-part
              </span>
            </div>

            <h1
              data-testid="hero-title"
              className="font-serif text-white text-[2rem] sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.08] tracking-tight font-light fade-in-up"
              style={{ animationDelay: "0.15s" }}
            >
              A Tisza partján a tűz melegénél,
              <br />
              jó emberek között,
              <br />
              <span className="italic text-pkred font-medium hero-fire-title">
                itt kezdődik a történet.
              </span>
            </h1>

            <p
              data-testid="hero-subtitle"
              className="mt-8 text-white/85 text-base sm:text-lg max-w-2xl leading-relaxed fade-in-up"
              style={{ animationDelay: "0.3s" }}
            >
              Szabadtűzi ételek, vidéki vendégszeretet, kemencés élmények és
              természetközeli kikapcsolódás Vezsenyen. Itt az idő lelassul, az
              ízek elmélyülnek.
            </p>

            <div
              className="mt-12 flex flex-col sm:flex-row gap-4 fade-in-up"
              style={{ animationDelay: "0.45s" }}
            >
              <a
                href="#kapcsolat"
                data-testid="hero-cta-reservation"
                className="btn-fire"
              >
                Asztalfoglalás
              </a>
              <a
                href="#programok"
                data-testid="hero-cta-programs"
                className="btn-ghost"
              >
                <Calendar className="w-4 h-4" strokeWidth={1.8} />
                Programok megtekintése
              </a>
            </div>
          </div>
        </div>

        {/* Scroll hint */}
        <a
          href="#intro"
          data-testid="hero-scroll-hint"
          className="absolute bottom-8 right-8 sm:right-12 hidden sm:flex flex-col items-center gap-3 text-white/70 hover:text-pkred transition-colors group"
        >
          <span className="text-[0.65rem] tracking-[0.3em] uppercase rotate-90 origin-bottom-right translate-y-[-30px]">
            Görgess
          </span>
          <ArrowDown
            className="w-4 h-4 animate-bounce mt-10"
            strokeWidth={1.5}
          />
        </a>
      </div>
    </section>
  );
}
